module.exports = __webpack_public_path__ + "img/pubgm-hs-mask.6b038c5.jpg";